import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import Constants from "expo-constants";
import appConfig from "../../config/app-config";
import i18n from "../language/i18n";
import auth from "./auth";
import store from "../store/store";
import { showModal } from "app/modules/modal-management/reducer/action";

declare module "axios" {
  export interface AxiosRequestConfig {
    throwAccessDenied?: boolean; // is true if you want to self handle access denied exception
  }
}

export const axiosConfig = () => {
  let config: AxiosRequestConfig = {
    headers: {
      "Accept-Language": i18n.language,
      "Content-Type": "application/json",
      "X-Frame-Options": "SAMEORIGIN",
    },
    timeout: 60 * 3 * 1000,
    baseURL: appConfig.url,
  };
  return config;
};

export const createService = (): AxiosInstance => {
  const instance = axios.create(axiosConfig());
  instance.defaults.timeout = 60 * 3 * 1000;
  instance.interceptors.request.use(async (request) => {
    if (request.url?.indexOf(Constants.manifest.extra?.KEYCLOAK_URL) === -1)
      request.headers = {
        ...request.headers,
        "Accept-Version": Constants.manifest.extra?.APP_ENV,
      };
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${auth.accessToken}`,
    };
    return request;
  });

  instance.interceptors.response.use(
    (response) => {
      console.log("success: ", response);
      response.headers = {
        ...response.headers,
      };
      return response;
    },
    async (error: AxiosError) => {
      console.log("failed response: ", error.response);
      // If token expired, refresh token and retry request
      if (error.response?.status === 401 && (error.response.data as string).indexOf("expired") !== -1) {
        await auth.refreshToken();
        return Promise.resolve(instance(error.config));
      }

      return Promise.reject(error);
    },
  );
  return instance;
};

export const instanceService = createService();

export const getErrorMessageKeyClock = (error: any | AxiosError, isShowError: boolean) => {
  let msgError: string = i18n.t("COMMON_LOI_KHONG_KET_NOI_DUOC_MAY_CHU");
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.error_description) msgError = error.response.data.error_description;
  }
  if (isShowError) {
    store.dispatch(
      showModal({
        modalType: "alert",
        modalProps: {
          open: true,
          message: msgError,
        },
      }),
    );
  }
  return msgError;
};

export const getErrorMessage = (error: any | AxiosError, isShowError: boolean, isLogout?: boolean) => {
  let msgError: string = i18n.t("COMMON_LOI_KHONG_KET_NOI_DUOC_MAY_CHU");
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.title) msgError = error.response.data.title;
  }
  // Với trường hợp hết phiên
  if (error.response?.status === 401) {
    store.dispatch(
      showModal({
        modalType: "alert",
        modalProps: {
          open: true,
          message: i18n.t("COMMON_THONG_BAO_HET_PHIEN"),
          logout: true,
        },
      }),
    );
  }
  if (isShowError) {
    store.dispatch(
      showModal({
        modalType: "alert",
        modalProps: {
          open: true,
          message: msgError,
          logout: isLogout,
        },
      }),
    );
  }
  return msgError;
};

// Card "304" = "E46"
// Card "306" = "E56"

const ERROR_END_OTP = ["E56", "E96", "E46", "304", "305"];

export const getErrorEndOTP = (error: any | AxiosError) => {
  if (axios.isAxiosError(error)) {
    const errorKey: string = error.response?.data?.errorKey || "";
    // if (errorKey && errorKey.length && ERROR_END_OTP.includes(errorKey)) return true;
    if (errorKey && errorKey.length && errorKey === "E34") return false;
  }
  return true;
};
